(() => {
  const bind = (root = document) => {
    root.querySelectorAll('.ss-instruments-nav, .ss-instruments-mobile').forEach(menu => {
      if (menu.dataset.ssBound) return;
      menu.dataset.ssBound = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        menu.open = false;
        menu.querySelector('summary').focus();
      });
      document.addEventListener('click', event => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
    root.querySelectorAll('.ss-form').forEach(form => {
      if (form.dataset.ssBound) return;
      form.dataset.ssBound = 'true';
      const audience = form.querySelector('[data-ss-audience]');
      const help = form.querySelector('[data-ss-form-help]');
      const update = () => {
        if (help && audience) help.textContent = audience.value === 'Distributor' ? help.dataset.distributorHelp : help.dataset.farmHelp;
      };
      audience?.addEventListener('change', update);
      update();
      const success = form.querySelector('[data-ss-success]');
      if (success) {
        success.focus({ preventScroll: true });
        success.scrollIntoView({ block: 'center' });
        document.dispatchEvent(new CustomEvent('ss:lead-success', { detail: { formId: form.id } }));
      }
    });
    root.querySelectorAll('.ss-product-gallery').forEach(gallery => {
      if (gallery.dataset.ssBound) return;
      gallery.dataset.ssBound = 'true';
      const image = gallery.querySelector('.ss-gallery-main');
      const links = gallery.querySelectorAll('[data-ss-gallery-link]');
      links.forEach(link => link.addEventListener('click', event => {
        if (!image || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const change = () => {
          image.src = link.dataset.imageSrc;
          image.removeAttribute('srcset');
          image.alt = link.dataset.imageAlt;
          links.forEach(item => item.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'true');
        };
        if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const transition = document.startViewTransition(change);
          gallery.addEventListener('pointerdown', () => transition.skipTransition(), { once: true });
        } else change();
      }));
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ss-revealed');
        observer.unobserve(entry.target);
      }), { threshold: 0.15 });
      root.querySelectorAll('[data-ss-reveal]').forEach(element => observer.observe(element));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ss-event]');
    if (link) document.dispatchEvent(new CustomEvent('ss:document-click', { detail: { name: link.dataset.ssEvent } }));
  });
})();
